import { render, staticRenderFns } from "./ClasificacionGenerosPorSeguidores.vue?vue&type=template&id=63d5ee99&"
import script from "./ClasificacionGenerosPorSeguidores.vue?vue&type=script&lang=js&"
export * from "./ClasificacionGenerosPorSeguidores.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionGenerosPorSeguidores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports